import { createSelector } from 'reselect'
import { State } from 'index'

const storeDeliveryFeeSelector = (state: State) => state.storeDeliveryFee

export const getStoreDeliveryFees = createSelector([storeDeliveryFeeSelector], (state) => state.storeDeliveryFees)
